export default "__VITE_ASSET__CtmRI31M__"